import { SESSION_TIMING_UPDATED, SESSION_TIMING_CLEARED } from './actions';

// Inlined to avoid pulling in LoginActions' heavy import chain (ui-home/Layout).
// Must stay in sync with LoginActions.logoutActionType.
const LOGOUT_ACTION_TYPE = 'mainlayout/logoutactiontype';

export const initialState = {
  timeoutMins: null,
  promptMins: null,
  lastRefreshedAt: null,
};

const sessionTimingReducer = (state = initialState, action) => {
  switch (action.type) {
    case SESSION_TIMING_UPDATED:
      return {
        ...state,
        timeoutMins: action.payload.timeoutMins,
        promptMins: action.payload.promptMins,
        lastRefreshedAt: action.payload.lastRefreshedAt,
      };

    case SESSION_TIMING_CLEARED:
    case LOGOUT_ACTION_TYPE:
      return initialState;

    default:
      return state;
  }
};

export default sessionTimingReducer;
